import React from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import StyledButton from '../StyledButton'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minHeight: 200,
      alignItems: 'center',
      textAlign: 'center',
      fontFamily: 'Libre Franklin',
      fontSize: 20,
      fontWeight: 300,
      lineHeight: '32px',
      margin: '160px 110px 100px',
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
        lineHeight: '28px',
        margin: '80px 23px',
        maxHeight: 350,
      },
    },
    title: {
      fontFamily: 'Quicksand',
      fontWeight: 600,
      fontSize: 40,
      lineHeight: '44px',
      [theme.breakpoints.down('sm')]: {
        fontSize: 32,
        lineHeight: '40px',
      },
    },
  }),
)

const Success: React.FC = () => {
  const classes = useStyles()
  const mediaMobile = useMediaQuery('(max-width:500px)')
  const media360 = useMediaQuery('(max-width:360px)')
  return (
    <div className={classes.container}>
      <p className={classes.title}>Thank you for your interest</p>
      <p>We promise to update you should we proceed with these premium offers</p>
      <StyledButton
        testId="back-to-refinance-button"
        width={media360 ? 'auto' : 275}
        style={{ marginRight: mediaMobile ? 0 : '27px' }}
        handleClick={() => window.location.reload()}
      >
        Back to Refinance Index
      </StyledButton>
    </div>
  )
}

export default Success
